import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import VClamp from 'vue-clamp';
import { useVModel } from '@vueuse/core';
import { debounce, isEqual, sortBy } from 'lodash-es';
import { BottomControlsButtons } from '~/core/components';
import SearchBar from '~/core/components/SearchBar/SearchBar.vue';
import FullscreenGallery from '~/core/components/FullscreenGallery/FullscreenGallery.vue';
import { getFileInfoFromBlob } from '~/core/functions';
import useMedcardDocumentsStore from '~/stores/useMedcardDocumentsStore';
import { DocumentGroupStatus, MedcardDocumentType } from '~/features/Medcard/enums';
import { MedcardApi } from '~/features/Medcard/api/medcard.api';
import { decryptFile } from '~/features/Medcard/functions';
import getDocumentGroupDate from '~/features/Medcard/functions/getDocumentGroupDate';
export default defineComponent({
  name: 'NewDocumentToFolderPopup',
  components: {
    FullscreenGallery: FullscreenGallery,
    VClamp: VClamp,
    SearchBar: SearchBar,
    BottomControlsButtons: BottomControlsButtons
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    documentsIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['update:value', 'add:documents'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var medcardDocumentsStore = useMedcardDocumentsStore();
    var gallery = ref(null);
    var documentSearchQuery = ref('');
    var filteredDocumentsGroups = ref([]);
    var documentIdOnPreview = ref(null);
    var selectedDocumentsIds = ref([]);
    var isActive = useVModel(props, 'value', emit);
    var documentsGroups = computed(function () {
      return medcardDocumentsStore.medcardDocumentGroups;
    });
    var isSubmitButtonDisabled = computed(function () {
      return isEqual(_toConsumableArray(props.documentsIds).sort(), _toConsumableArray(selectedDocumentsIds.value).sort());
    });
    onMounted(function () {
      watch(documentSearchQuery, debouncedGetFilteredDocumentsGroups, {
        immediate: true
      });
    });
    watch(isActive, function (val) {
      if (!val) {
        documentSearchQuery.value = '';
        return;
      }
      selectedDocumentsIds.value = _toConsumableArray(props.documentsIds);
      filteredDocumentsGroups.value = getFilteredDocumentsGroups();
    }, {
      immediate: true
    });
    function getFilteredDocumentsGroups() {
      if (!documentSearchQuery.value) {
        return documentsGroups.value;
      }
      return documentsGroups.value.map(function (group) {
        return [group[0], group[1].filter(function (item) {
          return item.documentInfo.toLowerCase().includes(documentSearchQuery.value.toLowerCase());
        })];
      }).filter(function (group) {
        return group[1].length;
      });
    }
    function handleCheckboxChange(val, id) {
      if (val) {
        selectedDocumentsIds.value.push(id);
      } else {
        selectedDocumentsIds.value = selectedDocumentsIds.value.filter(function (item) {
          return item !== id;
        });
      }
    }
    var debouncedGetFilteredDocumentsGroups = debounce(function () {
      filteredDocumentsGroups.value = getFilteredDocumentsGroups();
    }, 200);
    function handleClickSubmit() {
      emit('add:documents', selectedDocumentsIds.value);
      documentSearchQuery.value = '';
      isActive.value = false;
    }
    function handleShowGallery(_x) {
      return _handleShowGallery.apply(this, arguments);
    }
    function _handleShowGallery() {
      _handleShowGallery = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(documentId) {
        var _gallery$value;
        var _yield$Promise$all, _yield$Promise$all2, keyData, documentGroupRaw, sortedDocuments, documentDate;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              documentIdOnPreview.value = documentId;
              _context2.next = 3;
              return Promise.all([MedcardApi.getKey(documentId), MedcardApi.get(documentId)]);
            case 3:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              keyData = _yield$Promise$all2[0].data;
              documentGroupRaw = _yield$Promise$all2[1].data;
              _context2.t0 = sortBy;
              _context2.next = 10;
              return Promise.all(documentGroupRaw.documents);
            case 10:
              _context2.t1 = _context2.sent;
              _context2.t2 = ['sortIndex'];
              sortedDocuments = (0, _context2.t0)(_context2.t1, _context2.t2);
              documentDate = getDocumentGroupDate(documentGroupRaw);
              (_gallery$value = gallery.value) === null || _gallery$value === void 0 ? void 0 : _gallery$value.show(sortedDocuments.map(function (document, index) {
                return {
                  id: document.id,
                  source: function () {
                    var _source = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                      var _fileInfo$extension;
                      var _yield$MedcardApi$get, encryptedFile, blobPart, fileIndex, fileInfo, fileName;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return MedcardApi.getDocument(document.file);
                          case 2:
                            _yield$MedcardApi$get = _context.sent;
                            encryptedFile = _yield$MedcardApi$get.data;
                            _context.next = 6;
                            return decryptFile(encryptedFile, keyData.key, document.iv);
                          case 6:
                            _context.t0 = _context.sent;
                            blobPart = [_context.t0];
                            fileIndex = index ? "(".concat(index, ")") : '';
                            _context.next = 11;
                            return getFileInfoFromBlob(new Blob(blobPart));
                          case 11:
                            fileInfo = _context.sent;
                            fileName = "".concat(documentGroupRaw.documentInfo, " ").concat(documentDate).concat(fileIndex).concat((_fileInfo$extension = fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.extension) !== null && _fileInfo$extension !== void 0 ? _fileInfo$extension : '.pdf');
                            return _context.abrupt("return", new File(blobPart, fileName, {
                              type: fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.type
                            }));
                          case 14:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    }));
                    function source() {
                      return _source.apply(this, arguments);
                    }
                    return source;
                  }(),
                  name: documentGroupRaw.documentInfo,
                  date: documentDate
                };
              }));
              documentIdOnPreview.value = null;
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _handleShowGallery.apply(this, arguments);
    }
    return {
      gallery: gallery,
      MedcardDocumentType: MedcardDocumentType,
      isActive: isActive,
      documentSearchQuery: documentSearchQuery,
      filteredDocumentsGroups: filteredDocumentsGroups,
      documentIdOnPreview: documentIdOnPreview,
      isSubmitButtonDisabled: isSubmitButtonDisabled,
      selectedDocumentsIds: selectedDocumentsIds,
      DocumentGroupStatus: DocumentGroupStatus,
      handleClickSubmit: handleClickSubmit,
      handleShowGallery: handleShowGallery,
      handleCheckboxChange: handleCheckboxChange
    };
  }
});